import { useQuery } from '@tanstack/react-query'

import { coreAgentStatusQueryKey, getCoreAgentStatus } from './api'

/** 共享 Hub Agent 启用状态，错误必须由消费页面显式处理。 */
export function useCoreAgentStatus() {
  return useQuery({
    queryFn: getCoreAgentStatus,
    queryKey: coreAgentStatusQueryKey,
    staleTime: 60_000,
  })
}
